<template>
  <div id="dashboard">
    <main-layout>
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <template v-for="tab in tabs">
          <v-tab :key="tab.value" ripple :href="`#${tab.value}`">{{ $t(tab.text) }}</v-tab>
        </template>
      </v-tabs>
      <template v-if="currentView == 'customers'">
        <template v-if="selectedBot.theme == 'universalutilities'">
          <component :is="'uu-customers'"></component>
        </template>
        <template v-else-if="selectedBot.theme == 'kasikorncareer'">
          <component :is="'kasikorn-career'"></component>
        </template>
        <template v-else-if="selectedBot.theme == 'atomicboy'">
          <component :is="'atomicboy-customers'"></component>
        </template>
        <template v-else-if="['toa'].includes(selectedBot.theme)">
          <component :is="'ToaCustomer'"></component>
        </template>
        <template v-else-if="['centralhr'].includes(selectedBot.theme)">
          <component :is="'CentralHRCustomer'"></component>
        </template>
        <template v-else>
          <component :is="currentView"></component>
        </template>
      </template>
      <template v-else-if="currentView == 'employee'">
        <component :is="'hafele-customers'"></component>
      </template>
      <template v-else-if="currentView == 'FalesQuestion'">
        <component :is="'AtomicboyFalesQuestion'"></component>
      </template>
      <template v-else-if="currentView == 'GameLevelReport'">
        <component :is="'AtomicboyGameLevelReport'"></component>
      </template>
      <template v-else-if="currentView == 'user-tags'">
        <component :is="'UserTags'"></component>
      </template>
      <template v-else-if="currentView == 'AdminSatisfactionSurvey'">
        <component :is="'AdminSatisfactionSurvey'"></component>
      </template>
      <template v-else-if="currentView == 'satisfaction-survey-report'">
        <component :is="'GeneraliSatisfactionSurveyReport'"></component>
      </template>
      <template v-else-if="currentView == 'survey'">
        <component :is="'SurveyReport'"></component>
      </template>
      <template v-else>
        <component :is="currentView"></component>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'

import SahapanCustomers from './customize/sahapan/SahapanCustomers'
import KasikornCareer from './customize/kasikorn/KasikornCareer'
import UuCustomers from './customize/uu/UuCustomers'
import HafeleCustomers from './customize/hafele/HafeleCustomers'
import ToaCustomer from './customize/ToaCustomer.vue'
import AtomicboyCustomers from './customize/atomicboy/AtomicboyCustomers.vue'
import AtomicboyFalesQuestion from './customize/atomicboy/AtomicboyFalesQuestion.vue'
import AtomicboyGameLevelReport from './customize/atomicboy/AtomicboyGameLevelReport.vue'

import KasikornPersonalityTest from './customize/kasikorn/KasikornPersonalityTest'
import KasikornDigitalSkill from './customize/kasikorn/KasikornDigitalSkill'
import RamapoisonCustomers from './customize/ramapoison/RamapoisonCustomers.vue'
import Ceemeagain from './customize/Ceemeagain.vue'

import TagReport from './tag/TagReport.vue'
import SahapanTopLocation from './customize/sahapan/SahapanTopLocation.vue'
import SahapanTopRewardPoint from './customize/sahapan/SahapanTopRewardPoint.vue'
import StatCustomer from './stat/StatCustomer.vue'
import StatSummary from './stat/StatSummary.vue'
import ActiveUserGraph from './active-user/ActiveUserGraph.vue'
import Customers from './customer/Customers.vue'
import SummaryIntent from './SummaryIntent.vue'
import InboxStatRegister from './inbox/InboxStatRegister.vue'
import InboxStatFaculty from './inbox/InboxStatFaculty.vue'
import InboxStatScholarships from './inbox/InboxStatScholarships.vue'
import AstonDashboard from './customize/aston/AstonDashboard.vue'
import AstonLineDashboard from './customize/aston/AstonLineDashboard.vue'
import AstonOutsourceDashboard from './customize/aston/AstonOutsourceDashboard.vue'
import AstonDashboardAdminMessage from './customize/aston/AstonDashboardAdminMessage.vue'
import AstonDashboardAdminTiming from './customize/aston/AstonDashboardAdminTiming.vue'
import AstonDashboardFeedback from './customize/aston/AstonDashboardFeedback.vue'
import RussianRouletteDashboard from './customize/RussianRouletteDashboard.vue'
import AstonConversationRate from './customize/aston/AstonConversationRate.vue'
import NeoMoneyUserSummary from './customize/NeoMoneyUserSummary.vue'
import BranchLocation from './customize/BranchLocation.vue'
import SupertenDashboard from './customize/superten/SupertenDashboard.vue'
import AtomicStudentSummary from './customize/atomicboy/AtomicStudentSummary.vue'
import CentralHRCustomer from './customize/centralhr/CentralHRCustomer.vue'
import EmployeeInfo from './customize/centralhr/EmployeeInfo.vue'
import VotingResult from './customize/tero/VotingResult.vue'
import Participate from './customize/tero/Participate.vue'
import ScgdistributionInterest from './customize/ScgdistributionInterest.vue'
import Participants from './customize/Participants.vue'
import Voteresult from './customize/Voteresult.vue'
import TagsAndStatus from './tag/TagsAndStatus.vue'
import ConversationDetails from './customize/toapaint/ConversationDetails.vue'
import GpfAnswerReport from './customize/GpfAnswerReport.vue'
import UserTags from './customize/tisco/UserTags.vue'
import AdminSatisfactionSurvey from './customize/juzmatch/AdminSatisfactionSurvey.vue'
import GeneraliSatisfactionSurveyReport from './customize/generali/SatisfactionSurveyReport'
import SurveyReport from './survey/SurveyReport.vue'
import Reason from './customize/nt/Reason'

import Overview from './Overview.vue'
import Inbox from './Inbox.vue'
import Comment from './Comment.vue'
import { PAGE } from '@/constants/page.js'
export default {
  name: 'DashboardComponent',
  components: {
    AtomicboyGameLevelReport,
    AtomicboyFalesQuestion,
    StatSummary,
    ToaCustomer,
    AstonDashboard,
    AstonLineDashboard,
    ActiveUserGraph,
    SummaryIntent,
    Customers,
    UuCustomers,
    KasikornCareer,
    HafeleCustomers,
    AtomicboyCustomers,
    TagReport,
    InboxStatRegister,
    InboxStatFaculty,
    AstonOutsourceDashboard,
    InboxStatScholarships,
    KasikornPersonalityTest,
    KasikornDigitalSkill,
    StatCustomer,
    AstonDashboardAdminMessage,
    AstonDashboardAdminTiming,
    AstonDashboardFeedback,
    SahapanTopLocation,
    SahapanTopRewardPoint,
    RussianRouletteDashboard,
    SahapanCustomers,
    NeoMoneyUserSummary,
    AstonConversationRate,
    RamapoisonCustomers,
    Ceemeagain,
    BranchLocation,
    SupertenDashboard,
    AtomicStudentSummary,
    CentralHRCustomer,
    VotingResult,
    Participate,
    EmployeeInfo,
    ScgdistributionInterest,
    Participants,
    Voteresult,
    TagsAndStatus,
    ConversationDetails,
    GpfAnswerReport,
    Overview,
    Inbox,
    Comment,
    UserTags,
    AdminSatisfactionSurvey,
    GeneraliSatisfactionSurveyReport,
    SurveyReport,
    Reason
  },
  data: function () {
    return {
      showIntent: false,
      currentView: ''
    }
  },
  computed: {
    astonpages() {
      return this.$aston.astonpages
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isRussianRoulette() {
      return this.$store.state.pageRussianRoulette.includes(this.selectedBot.pageid)
    },
    isAiraAifulPage() {
      return PAGE.AIRA_AIFUL.includes(this.selectedBot.pageid)
    },
    tabs() {
      const mainTabs = [
        {
          value: 'stat-summary',
          text: 'Dashboard'
        },
        {
          value: 'active-user-graph',
          text: 'Metrics'
        },
        {
          value: 'summary-intent',
          text: 'Conversation'
        }
      ]
      if (this.selectedBot.theme == 'sahapan') {
        return [
          {
            value: 'stat-customer',
            text: 'Customer Analytic'
          },
          ...mainTabs,
          {
            value: 'SahapanCustomers',
            text: 'Customer'
          },
          {
            value: 'SahapanTopLocation',
            text: 'Top Location'
          },
          {
            value: 'SahapanTopRewardPoint',
            text: 'Top Reward'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (this.isBU) {
        return [
          {
            value: 'customers',
            text: 'Customer'
          },
          ...mainTabs,
          {
            value: 'inbox-stat-register',
            text: 'Register'
          },
          {
            value: 'inbox-stat-faculty',
            text: 'Faculty'
          },
          {
            value: 'inbox-stat-scholarships',
            text: 'Scholarships'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (
        this.selectedBot.theme == 'universalutilities' &&
        this.$store.state.userid == 'uuadmin'
      ) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          }
        ]
      } else if (['2428337527228612', '106728661059512'].includes(this.selectedBot.pageid)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'neo-money-user-summary',
            text: 'User Summary'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (
        this.$store.state.newDeshboard.includes(this.selectedBot.pageid) ||
        this.isAiraAifulPage
      ) {
        return [
          {
            value: 'overview',
            text: 'Dashboard'
          },
          {
            value: 'inbox',
            text: 'inbox'
          },
          {
            value: 'comment',
            text: 'Comment'
          },
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (
        this.selectedBot.pageid == '105911105134578' ||
        this.selectedBot.pageid == '101931352240400' ||
        this.$store.state.pageListSingGaling.includes(this.selectedBot.pageid)
      ) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'Voteresult',
            text: 'VOTING RESULT'
          },
          {
            value: 'Participants',
            text: 'PARTICIPANTS'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (this.selectedBot.theme == 'atomicboy') {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'FalesQuestion',
            text: 'WRONG ANSWER REPORT'
          },
          {
            value: 'GameLevelReport',
            text: 'GAME LEVEL REPORT'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['ramapoisoncenter'].includes(this.selectedBot.theme)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'RamapoisonCustomers',
            text: 'Customer'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (this.selectedBot.theme == 'kasikorncareer') {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Career Matching'
          },
          {
            value: 'kasikorn-personality-test',
            text: 'Personality Test'
          },
          {
            value: 'kasikorn-digital-skill',
            text: 'Digital Skill'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['generalixwarroom', 'generali'].includes(this.selectedBot.theme)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'satisfaction-survey-report',
            text: 'satisfaction_survey_report'
          },
          {
            value: 'tag-report',
            text: 'Tag'
          }
        ]
      } else if (
        this.astonpages.includes(this.selectedBot.pageid) &&
        this.$store.getters.getPackage == 'premium'
      ) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'aston-dashboard',
            text: 'Aston'
          },
          {
            value: 'aston-line-dashboard',
            text: 'AstonLine'
          },
          {
            value: 'aston-outsource-dashboard',
            text: 'Outsource'
          },
          {
            value: 'aston-dashboard-admin-message',
            text: 'Admin message'
          },
          {
            value: 'AstonConversationRate',
            text: 'Conversation Rate'
          },
          {
            value: 'aston-dashboard-admin-timing',
            text: 'AdminTiming'
          },
          {
            value: 'aston-dashboard-feedback',
            text: 'Feedback'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (
        ['ceemeagain'].includes(this.selectedBot.theme) &&
        this.$store.getters.getPackage == 'premium'
      ) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'ceemeagain',
            text: 'Ceemeagain'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (this.$store.state.supertenpage.includes(this.selectedBot.pageid)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'superten-dashboard',
            text: 'Vote'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['scgdistribution'].includes(this.selectedBot.theme)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'ScgdistributionInterest',
            text: 'Check-in'
          }
        ]
      } else if (['102074341651763'].includes(this.selectedBot.pageid)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'atomic-student-summary',
            text: 'Student Summary'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['tero'].includes(this.selectedBot.theme)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'voting-result',
            text: 'Voting Result'
          },
          {
            value: 'participate',
            text: 'Participants'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['centralhr'].includes(this.selectedBot.theme)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'EmployeeInfo',
            text: 'Employee Summary'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if ([...this.$store.state.lamyPage].includes(this.selectedBot.pageid)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'LamyBehaviorReport',
            text: 'Behavior Report'
          },
          {
            value: 'LamyWarranty',
            text: 'Warranty'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (this.selectedBot && this.selectedBot.type === 'gpf') {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'gpf-answer-report',
            text: 'answer_report'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if ([...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'conversation-details',
            text: 'conversation_details'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['autocash'].includes(this.selectedBot.type)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          },
          {
            value: 'user-tags',
            text: 'user_tags'
          }
        ]
      } else if (PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'AdminSatisfactionSurvey',
            text: 'ประเมินความพึงพอใจแอดมิน'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      } else if (['phyathai'].includes(this.selectedBot.type)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          },
          {
            value: 'survey',
            text: 'survey'
          }
        ]
      } else if (['nt'].includes(this.selectedBot.type)) {
        return [
          ...mainTabs,
          {
            value: 'customers',
            text: 'Customer'
          },
          {
            value: 'reason',
            text: 'Reason'
          },
          {
            value: 'tags-and-status',
            text: 'Tags/Status'
          }
        ]
      }

      return [
        ...mainTabs,
        {
          value: 'customers',
          text: 'Customer'
        },
        {
          value: 'tags-and-status',
          text: 'Tags/Status'
        }
      ]
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  },
  created: function () {
    let vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      if (this.selectedBot.theme == 'universalutilities' && this.$store.state.userid != 'uuadmin') {
        vm.currentView = 'customers'
      } else if (this.isAiraAifulPage) {
        vm.currentView = 'overview'
      } else {
        vm.currentView = 'stat-summary'
      }
    }
  },
  methods: {
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
    updateRoute: function () {
      this.$router
        .push({
          name: 'dashboard',
          path: '/dashboard',
          query: {
            tab: this.currentView
          }
        })
        .catch(() => {})
      this.routeValue = JSON.stringify(this.$route.query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Dashboard.vue